export default "__VITE_ASSET__2qPOEy4y__"